export const SEARCH_FILE_TYPES = [
    {name: 'Folders', type: 'folder'},
    {name: 'ZIPs', type: 'zip-archive'},
    {name: 'RARs', type: 'rar-archive'},
    {name: 'ISOs', type: 'iso'},
    {name: 'Torrents', type: 'torrent'},
    {name: 'APKs', type: 'apk'},
];
